export const countryData = [
    { geoID: 2004, name: "Afghanistan", countryCode: "AF" },
    { geoID: 2008, name: "Albania", countryCode: "AL" },
    { geoID: 2012, name: "Algeria", countryCode: "DZ" },
    { geoID: 2016, name: "American Samoa", countryCode: "AS" },
    { geoID: 2020, name: "Andorra", countryCode: "AD" },
    { geoID: 2024, name: "Angola", countryCode: "AO" },
    { geoID: 2010, name: "Antarctica", countryCode: "AQ" },
    { geoID: 2028, name: "Antigua and Barbuda", countryCode: "AG" },
    { geoID: 2032, name: "Argentina", countryCode: "AR" },
    { geoID: 2051, name: "Armenia", countryCode: "AM" },
    { geoID: 2036, name: "Australia", countryCode: "AU" },
    { geoID: 2040, name: "Austria", countryCode: "AT" },
    { geoID: 2031, name: "Azerbaijan", countryCode: "AZ" },
    { geoID: 2048, name: "Bahrain", countryCode: "BH" },
    { geoID: 2050, name: "Bangladesh", countryCode: "BD" },
    { geoID: 2052, name: "Barbados", countryCode: "BB" },
    { geoID: 2112, name: "Belarus", countryCode: "BY" },
    { geoID: 2056, name: "Belgium", countryCode: "BE" },
    { geoID: 2084, name: "Belize", countryCode: "BZ" },
    { geoID: 2204, name: "Benin", countryCode: "BJ" },
    { geoID: 2064, name: "Bhutan", countryCode: "BT" },
    { geoID: 2068, name: "Bolivia", countryCode: "BO" },
    { geoID: 2070, name: "Bosnia and Herzegovina", countryCode: "BA" },
    { geoID: 2072, name: "Botswana", countryCode: "BW" },
    { geoID: 2076, name: "Brazil", countryCode: "BR" },
    { geoID: 2096, name: "Brunei", countryCode: "BN" },
    { geoID: 2100, name: "Bulgaria", countryCode: "BG" },
    { geoID: 2854, name: "Burkina Faso", countryCode: "BF" },
    { geoID: 2108, name: "Burundi", countryCode: "BI" },
    { geoID: 2116, name: "Cambodia", countryCode: "KH" },
    { geoID: 2120, name: "Cameroon", countryCode: "CM" },
    { geoID: 2124, name: "Canada", countryCode: "CA" },
    { geoID: 2132, name: "Cape Verde", countryCode: "CV" },
    { geoID: 2535, name: "Caribbean Netherlands", countryCode: "BQ" },
    { geoID: 2140, name: "Central African Republic", countryCode: "CF" },
    { geoID: 2148, name: "Chad", countryCode: "TD" },
    { geoID: 2152, name: "Chile", countryCode: "CL" },
    { geoID: 2156, name: "China", countryCode: "CN" },
    { geoID: 2162, name: "Christmas Island", countryCode: "CX" },
    { geoID: 2166, name: "Cocos (Keeling) Islands", countryCode: "CC" },
    { geoID: 2170, name: "Colombia", countryCode: "CO" },
    { geoID: 2174, name: "Comoros", countryCode: "KM" },
    { geoID: 2184, name: "Cook Islands", countryCode: "CK" },
    { geoID: 2188, name: "Costa Rica", countryCode: "CR" },
    { geoID: 2384, name: "Cote d'Ivoire", countryCode: "CI" },
    { geoID: 2191, name: "Croatia", countryCode: "HR" },
    { geoID: 2531, name: "Curacao", countryCode: "CW" },
    { geoID: 2196, name: "Cyprus", countryCode: "CY" },
    { geoID: 2203, name: "Czechia", countryCode: "CZ" },
    { geoID: 2180, name: "Democratic Republic of the Congo", countryCode: "CD" },
    { geoID: 2208, name: "Denmark", countryCode: "DK" },
    { geoID: 2262, name: "Djibouti", countryCode: "DJ" },
    { geoID: 2212, name: "Dominica", countryCode: "DM" },
    { geoID: 2214, name: "Dominican Republic", countryCode: "DO" },
    { geoID: 2218, name: "Ecuador", countryCode: "EC" },
    { geoID: 2818, name: "Egypt", countryCode: "EG" },
    { geoID: 2222, name: "El Salvador", countryCode: "SV" },
    { geoID: 2226, name: "Equatorial Guinea", countryCode: "GQ" },
    { geoID: 2232, name: "Eritrea", countryCode: "ER" },
    { geoID: 2233, name: "Estonia", countryCode: "EE" },
    { geoID: 2748, name: "Eswatini", countryCode: "SZ" },
    { geoID: 2231, name: "Ethiopia", countryCode: "ET" },
    { geoID: 2583, name: "Federated States of Micronesia", countryCode: "FM" },
    { geoID: 2242, name: "Fiji", countryCode: "FJ" },
    { geoID: 2246, name: "Finland", countryCode: "FI" },
    { geoID: 2250, name: "France", countryCode: "FR" },
    { geoID: 2258, name: "French Polynesia", countryCode: "PF" },
    {
        geoID: 2260,
        name: "French Southern and Antarctic Lands",
        countryCode: "TF",
    },
    { geoID: 2266, name: "Gabon", countryCode: "GA" },
    { geoID: 2268, name: "Georgia", countryCode: "GE" },
    { geoID: 2276, name: "Germany", countryCode: "DE" },
    { geoID: 2288, name: "Ghana", countryCode: "GH" },
    { geoID: 2300, name: "Greece", countryCode: "GR" },
    { geoID: 2308, name: "Grenada", countryCode: "GD" },
    { geoID: 2316, name: "Guam", countryCode: "GU" },
    { geoID: 2320, name: "Guatemala", countryCode: "GT" },
    { geoID: 2831, name: "Guernsey", countryCode: "GG" },
    { geoID: 2324, name: "Guinea", countryCode: "GN" },
    { geoID: 2624, name: "Guinea-Bissau", countryCode: "GW" },
    { geoID: 2328, name: "Guyana", countryCode: "GY" },
    { geoID: 2332, name: "Haiti", countryCode: "HT" },
    { geoID: 2334, name: "Heard Island and McDonald Islands", countryCode: "HM" },
    { geoID: 2340, name: "Honduras", countryCode: "HN" },
    { geoID: 2344, name: "Hong Kong", countryCode: "HK" },
    { geoID: 2348, name: "Hungary", countryCode: "HU" },
    { geoID: 2352, name: "Iceland", countryCode: "IS" },
    { geoID: 2356, name: "India", countryCode: "IN" },
    { geoID: 2360, name: "Indonesia", countryCode: "ID" },
    { geoID: 2368, name: "Iraq", countryCode: "IQ" },
    { geoID: 2372, name: "Ireland", countryCode: "IE" },
    { geoID: 2376, name: "Israel", countryCode: "IL" },
    { geoID: 2380, name: "Italy", countryCode: "IT" },
    { geoID: 2388, name: "Jamaica", countryCode: "JM" },
    { geoID: 2392, name: "Japan", countryCode: "JP" },
    { geoID: 2832, name: "Jersey", countryCode: "JE" },
    { geoID: 2400, name: "Jordan", countryCode: "JO" },
    { geoID: 2398, name: "Kazakhstan", countryCode: "KZ" },
    { geoID: 2404, name: "Kenya", countryCode: "KE" },
    { geoID: 2296, name: "Kiribati", countryCode: "KI" },
    { geoID: 2414, name: "Kuwait", countryCode: "KW" },
    { geoID: 2417, name: "Kyrgyzstan", countryCode: "KG" },
    { geoID: 2418, name: "Laos", countryCode: "LA" },
    { geoID: 2428, name: "Latvia", countryCode: "LV" },
    { geoID: 2422, name: "Lebanon", countryCode: "LB" },
    { geoID: 2426, name: "Lesotho", countryCode: "LS" },
    { geoID: 2430, name: "Liberia", countryCode: "LR" },
    { geoID: 2434, name: "Libya", countryCode: "LY" },
    { geoID: 2438, name: "Liechtenstein", countryCode: "LI" },
    { geoID: 2440, name: "Lithuania", countryCode: "LT" },
    { geoID: 2442, name: "Luxembourg", countryCode: "LU" },
    { geoID: 2450, name: "Madagascar", countryCode: "MG" },
    { geoID: 2454, name: "Malawi", countryCode: "MW" },
    { geoID: 2458, name: "Malaysia", countryCode: "MY" },
    { geoID: 2462, name: "Maldives", countryCode: "MV" },
    { geoID: 2466, name: "Mali", countryCode: "ML" },
    { geoID: 2470, name: "Malta", countryCode: "MT" },
    { geoID: 2584, name: "Marshall Islands", countryCode: "MH" },
    { geoID: 2478, name: "Mauritania", countryCode: "MR" },
    { geoID: 2480, name: "Mauritius", countryCode: "MU" },
    { geoID: 2484, name: "Mexico", countryCode: "MX" },
    { geoID: 2498, name: "Moldova", countryCode: "MD" },
    { geoID: 2492, name: "Monaco", countryCode: "MC" },
    { geoID: 2496, name: "Mongolia", countryCode: "MN" },
    { geoID: 2499, name: "Montenegro", countryCode: "ME" },
    { geoID: 2504, name: "Morocco", countryCode: "MA" },
    { geoID: 2508, name: "Mozambique", countryCode: "MZ" },
    { geoID: 2104, name: "Myanmar (Burma)", countryCode: "MM" },
    { geoID: 2516, name: "Namibia", countryCode: "NA" },
    { geoID: 2520, name: "Nauru", countryCode: "NR" },
    { geoID: 2524, name: "Nepal", countryCode: "NP" },
    { geoID: 2528, name: "Netherlands", countryCode: "NL" },
    { geoID: 2540, name: "New Caledonia", countryCode: "NC" },
    { geoID: 2554, name: "New Zealand", countryCode: "NZ" },
    { geoID: 2558, name: "Nicaragua", countryCode: "NI" },
    { geoID: 2562, name: "Niger", countryCode: "NE" },
    { geoID: 2566, name: "Nigeria", countryCode: "NG" },
    { geoID: 2570, name: "Niue", countryCode: "NU" },
    { geoID: 2574, name: "Norfolk Island", countryCode: "NF" },
    { geoID: 2807, name: "North Macedonia", countryCode: "MK" },
    { geoID: 2580, name: "Northern Mariana Islands", countryCode: "MP" },
    { geoID: 2578, name: "Norway", countryCode: "NO" },
    { geoID: 2512, name: "Oman", countryCode: "OM" },
    { geoID: 2586, name: "Pakistan", countryCode: "PK" },
    { geoID: 2585, name: "Palau", countryCode: "PW" },
    { geoID: 2591, name: "Panama", countryCode: "PA" },
    { geoID: 2598, name: "Papua New Guinea", countryCode: "PG" },
    { geoID: 2600, name: "Paraguay", countryCode: "PY" },
    { geoID: 2604, name: "Peru", countryCode: "PE" },
    { geoID: 2608, name: "Philippines", countryCode: "PH" },
    { geoID: 2612, name: "Pitcairn Islands", countryCode: "PN" },
    { geoID: 2616, name: "Poland", countryCode: "PL" },
    { geoID: 2620, name: "Portugal", countryCode: "PT" },
    { geoID: 2634, name: "Qatar", countryCode: "QA" },
    { geoID: 2178, name: "Republic of the Congo", countryCode: "CG" },
    { geoID: 2642, name: "Romania", countryCode: "RO" },
    { geoID: 2643, name: "Russia", countryCode: "RU" },
    { geoID: 2646, name: "Rwanda", countryCode: "RW" },
    { geoID: 2652, name: "Saint Barthelemy", countryCode: "BL" },
    {
        geoID: 2654,
        name: "Saint Helena, Ascension and Tristan da Cunha",
        countryCode: "SH",
    },
    { geoID: 2659, name: "Saint Kitts and Nevis", countryCode: "KN" },
    { geoID: 2662, name: "Saint Lucia", countryCode: "LC" },
    { geoID: 2663, name: "Saint Martin", countryCode: "MF" },
    { geoID: 2666, name: "Saint Pierre and Miquelon", countryCode: "PM" },
    { geoID: 2670, name: "Saint Vincent and the Grenadines", countryCode: "VC" },
    { geoID: 2882, name: "Samoa", countryCode: "WS" },
    { geoID: 2674, name: "San Marino", countryCode: "SM" },
    { geoID: 2678, name: "Sao Tome and Principe", countryCode: "ST" },
    { geoID: 2682, name: "Saudi Arabia", countryCode: "SA" },
    { geoID: 2686, name: "Senegal", countryCode: "SN" },
    { geoID: 2688, name: "Serbia", countryCode: "RS" },
    { geoID: 2690, name: "Seychelles", countryCode: "SC" },
    { geoID: 2694, name: "Sierra Leone", countryCode: "SL" },
    { geoID: 2702, name: "Singapore", countryCode: "SG" },
    { geoID: 2534, name: "Sint Maarten", countryCode: "SX" },
    { geoID: 2703, name: "Slovakia", countryCode: "SK" },
    { geoID: 2705, name: "Slovenia", countryCode: "SI" },
    { geoID: 2090, name: "Solomon Islands", countryCode: "SB" },
    { geoID: 2706, name: "Somalia", countryCode: "SO" },
    { geoID: 2710, name: "South Africa", countryCode: "ZA" },
    {
        geoID: 2239,
        name: "South Georgia and the South Sandwich Islands",
        countryCode: "GS",
    },
    { geoID: 2410, name: "South Korea", countryCode: "KR" },
    { geoID: 2728, name: "South Sudan", countryCode: "SS" },
    { geoID: 2724, name: "Spain", countryCode: "ES" },
    { geoID: 2144, name: "Sri Lanka", countryCode: "LK" },
    { geoID: 2736, name: "Sudan", countryCode: "SD" },
    { geoID: 2740, name: "Suriname", countryCode: "SR" },
    { geoID: 2752, name: "Sweden", countryCode: "SE" },
    { geoID: 2756, name: "Switzerland", countryCode: "CH" },
    { geoID: 2158, name: "Taiwan", countryCode: "TW" },
    { geoID: 2762, name: "Tajikistan", countryCode: "TJ" },
    { geoID: 2834, name: "Tanzania", countryCode: "TZ" },
    { geoID: 2764, name: "Thailand", countryCode: "TH" },
    { geoID: 2044, name: "The Bahamas", countryCode: "BS" },
    { geoID: 2270, name: "The Gambia", countryCode: "GM" },
    { geoID: 2626, name: "Timor-Leste", countryCode: "TL" },
    { geoID: 2768, name: "Togo", countryCode: "TG" },
    { geoID: 2772, name: "Tokelau", countryCode: "TK" },
    { geoID: 2776, name: "Tonga", countryCode: "TO" },
    { geoID: 2780, name: "Trinidad and Tobago", countryCode: "TT" },
    { geoID: 2788, name: "Tunisia", countryCode: "TN" },
    { geoID: 2792, name: "Turkey", countryCode: "TR" },
    { geoID: 2795, name: "Turkmenistan", countryCode: "TM" },
    { geoID: 2798, name: "Tuvalu", countryCode: "TV" },
    { geoID: 2800, name: "Uganda", countryCode: "UG" },
    { geoID: 2804, name: "Ukraine", countryCode: "UA" },
    { geoID: 2784, name: "United Arab Emirates", countryCode: "AE" },
    { geoID: 2826, name: "United Kingdom", countryCode: "GB" },
    { geoID: 2840, name: "United States", countryCode: "US" },
    {
        geoID: 2581,
        name: "United States Minor Outlying Islands",
        countryCode: "UM",
    },
    { geoID: 2858, name: "Uruguay", countryCode: "UY" },
    { geoID: 2860, name: "Uzbekistan", countryCode: "UZ" },
    { geoID: 2548, name: "Vanuatu", countryCode: "VU" },
    { geoID: 2336, name: "Vatican City", countryCode: "VA" },
    { geoID: 2862, name: "Venezuela", countryCode: "VE" },
    { geoID: 2704, name: "Vietnam", countryCode: "VN" },
    { geoID: 2876, name: "Wallis and Futuna", countryCode: "WF" },
    { geoID: 2887, name: "Yemen", countryCode: "YE" },
    { geoID: 2894, name: "Zambia", countryCode: "ZM" },
    { geoID: 2716, name: "Zimbabwe", countryCode: "ZW" },
];